import { BreadcrumbJSONLD } from '~/utils/json-ld/breadcrumb';
import { useAtomValue } from 'jotai';
import { useCategoryData } from '~/models/feed';
import { $Locale, $RootTraffic } from '@lemon8/web-app-shared/atom';
import { $CategoryList } from 'shared/atoms/common/category';
import { ItemListJSONLD } from '~/utils/json-ld/item-list';

export const JsonLD = (): JSX.Element => {
  const { categoryName } = useCategoryData();
  const { enterHref } = useAtomValue($RootTraffic);
  const { region } = useAtomValue($Locale);

  const categoryList = useAtomValue($CategoryList);
  const feedUrlList = categoryList.map((item) => {
    return `https://www.lemon8-app.com/feed/${item.name}?region=${region}`;
  });

  return (
    <>
      <BreadcrumbJSONLD nameList={['lemon8', 'feed', categoryName]} path={decodeURIComponent(enterHref)} />
      <ItemListJSONLD urlList={feedUrlList} />
    </>
  );
};
